<template lang='pug'>
  .post-module
    .post-module--thumbnail
      .post-module--date(:title='date')
        .day {{ showDay(news.published_at) }}
        .month {{ showMonth(news.published_at) }}
      a(v-bind:href='news.url' target="_blank")
        .post-module--thumbnail-bg(
          :style='{backgroundImage: "url(" + news.image.full_url + ")"}' v-if='news.image && news.image.full_url'
        )
      .post-module--source(:title='news.source.name')
        |{{ news.source.name }}
    .post-module--content
      h3.post-module--title(:title='title')
        a(v-bind:href='news.url') {{ title }}
      p.post-module--description(v-if='!news.source.lsr_active') {{ teaser }}
</template>

<script>

export default {
  props: ['news'],
  computed: {
    title() {
      return this.news.title.replace(/\u00A0/g, " ")
    },
    teaser() {
      return this.news.teaser.replace(/\s+/g, " ")
    },
    date() {
      const date = new Date(this.news.published_at);
      return date;
    }
  },
  methods: {
    showDay(date) {
      const publishedDate = new Date(date);
      return publishedDate.getDate();
    },

    showMonth(date) {
      const publishedDate = new Date(date);
      const month = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]

      return month[publishedDate.getMonth()];
    }
  },
}
</script>


<style lang="scss">

.post-module {
  position: relative;
  z-index: 1;
  display: block;
  background: #FFFFFF;
  min-width: 235px;
  height: 440px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
  transition: all 0.3s linear 0s;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  &:hover {
    box-shadow: 0px 1px 35px 0px rgba(0, 0, 0, 0.3);
    .post-module--thumbnail img {
      transform: scale(1.1);
      opacity: 0.6;
    }
  }
  .post-module--content {
    flex-grow: 1;
    background: #FFFFFF;
    width: 100%;
    padding: 5px 15px;
    box-sizing: border-box;
    transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
  }
}
.post-module--date {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
  background: #272e68;
  width: 55px;
  height: 55px;
  padding: 12.5px 0;
  border-radius: 100%;
  color: #FFFFFF;
  font-weight: 700;
  text-align: center;
  box-sizing: border-box;
  line-height: 1;
  .day {
    font-size: 18px;
  }
  .month {
    font-size: 12px;
    text-transform: uppercase;
  }
}
.post-module--thumbnail {
  position: relative;
  background: white;
  height: 210px !important;
  overflow: hidden;
  margin-bottom: 0px;
}
.post-module--source {
  position: absolute;
  bottom: 10px;
  left: 0;
  background: #272e68;
  padding: 10px 15px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.post-module--title {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #272e68;
  display: -webkit-box;
  font-size: 26px;
  font-weight: 700;
  hyphens: auto;
  margin: 7px 0;
  max-height: 60px;
  overflow-wrap: anywhere;
  overflow: hidden;
  padding: 0 0 10px;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  a {
    color: #272e68;
  }
}
.post-module--description {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  color: #666666;
  display: -webkit-box;
  font-size: 14px;
  hyphens: auto;
  line-height: 1.5em;
  margin-bottom: 0;
  margin-top: 0.5em;
  max-height: 145px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
}
.post-module--thumbnail-bg {
  width: 100%; height: 210px; background-position: center; background-repeat: no-repeat; background-size: cover;
  transition: all 0.3s linear 0s;
}
.post-module:hover {
  .description {
    opacity: 1 !important;
  }
  .post-module--thumbnail-bg {
    transform: scale(1.1);
    opacity: 0.6;
  }
}
</style>
